import { useQuery } from "@tanstack/react-query";
import { PoweredBy } from "@rekati/ui";
import { publicApi } from "../../app/api";
import { keys } from "../../app/keys";
import { useI18n } from "../../content/i18n";

/**
 * "Powered by iForte.AI | Rekati": the login page and the board. `dark` picks
 * the logos for an ink background; `rail` is the partner alone, small, under
 * the Rekati logo the console's sidebar already shows.
 */
export function Signature({
  dark = false,
  rail = false,
  className,
}: {
  dark?: boolean;
  rail?: boolean;
  className?: string;
}) {
  const { t } = useI18n();
  const brand = useQuery({ queryKey: keys.brand, queryFn: publicApi.brand, staleTime: 30 * 60_000 }).data;
  return (
    <PoweredBy
      label={t("meta.poweredBy")}
      poweredBy={{
        src: dark
          ? brand?.powered_by_logo_dark_url || brand?.powered_by_logo_url
          : brand?.powered_by_logo_url || brand?.powered_by_logo_dark_url,
        name: brand?.powered_by_name || "iForte.AI",
      }}
      platform={
        rail
          ? undefined
          : {
              src: dark
                ? brand?.platform_logo_dark_url || brand?.platform_logo_url
                : brand?.platform_logo_url || brand?.platform_logo_dark_url,
              name: brand?.platform_name || "Rekati",
            }
      }
      small={rail}
      className={className}
    />
  );
}
